import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const LANGUAGES = [
  { code: 'pt-BR', flag: '🇧🇷' },
  { code: 'en', flag: '🇺🇸' },
  { code: 'es', flag: '🇪🇸' },
  { code: 'fr', flag: '🇫🇷' },
  { code: 'it', flag: '🇮🇹' },
  { code: 'sv', flag: '🇸🇪' },
  { code: 'no', flag: '🇳🇴' },
  { code: 'da', flag: '🇩🇰' }
];

export const LanguageSelector = () => {
  const { t, currentLanguage, changeLanguage } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = LANGUAGES.find(lang => lang.code === currentLanguage) || LANGUAGES[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
        title={t('topBar.language')}
      >
        <span className="text-base">{currentLang.flag}</span>
        <span className="text-xs font-medium text-white hidden sm:inline">
          {t(`languages.${currentLanguage}`)}
        </span>
        <svg
          className={`w-3 h-3 text-white transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 rounded-lg bg-gray-800 shadow-xl border border-gray-700 z-50 overflow-hidden">
          <div className="p-1.5">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-lg text-left transition-colors focus:outline-none focus:ring-0 focus:border-0 border-0 ${
                  currentLanguage === lang.code
                    ? 'bg-pickiwi text-white hover:bg-pickiwi-dark border-0'
                    : 'text-gray-300 hover:bg-gray-700'
                }`}
                style={currentLanguage === lang.code ? { backgroundColor: '#7eb715', border: 'none' } : { border: 'none' }}
                onMouseEnter={(e) => {
                  if (currentLanguage === lang.code) {
                    e.target.style.backgroundColor = '#638C08';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentLanguage === lang.code) {
                    e.target.style.backgroundColor = '#7eb715';
                  }
                }}
              >
                <span className="text-base">{lang.flag}</span>
                <span className="text-xs font-medium">
                  {t(`languages.${lang.code}`)}
                </span>
                {currentLanguage === lang.code && (
                  <svg
                    className="w-3 h-3 ml-auto"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
